module.exports = __webpack_public_path__ + "assets/img/free_26.9d6009b0.png";